import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { MarkedText } from '~/eds/src/components/MarkedText/MarkedText';
import { Text } from '~/eds/src/components/Text/Text';
import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { WellKnownFields } from '~/features/ticket/types/well-known-fields';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { sortAndFilterWellKnownFields } from './utils';

interface Props {
  wellKnownFields: WellKnownFields;
  search?: string;
}

export const WellKnownFieldsFormInformation = ({
  wellKnownFields,
  search,
}: Props) => {
  const formatNumber = useFormatNumber();
  const formatDate = useFormatDate();
  const intl = useIntl();
  return (
    <Layout direction="column" id="well-known-fields" spacing={2}>
      <Text preset="description" pb={2}>
        <MarkedText
          search={search}
          text={intl.formatMessage({
            id: 'WellKnownFieldsFormInformation.linkedFieldsMessage',
            defaultMessage:
              'These fields are linked. To modify Go to Contract Summary.',
            description:
              'Message indicating that fields are linked and modifications require going to Contract Summary',
          })}
        />
      </Text>
      <Layout direction="column" spacing={3}>
        {sortAndFilterWellKnownFields(wellKnownFields.fields).map((field) => {
          let value = field.value;
          switch (field.type) {
            case WorkflowFieldType.Number:
              if (value !== null) {
                value = formatNumber(value as number);
              }
              break;
            case WorkflowFieldType.Date:
              value = value && formatDate(value, 'long');
              break;
            default:
              break;
          }
          return (
            <Layout key={field.name} direction="column" spacing={2} mb={3}>
              <MarkedText search={search} text={field.name} />
              <Text preset="description">{value ?? '-'}</Text>
            </Layout>
          );
        })}
      </Layout>
    </Layout>
  );
};
